<template>
    <div id="conteneur">
      <Toast />
      <HeaderHome :user="this.$store.state.user.prenom" />

      <div class="background">

        <!-- Colonne gauche : liste -->
        <div class="panel panel-list">

          <div class="panel-header">
            <div class="panel-header-left">
              <div>
                <p class="panel-label">Gestion</p>
                <h2 class="panel-title">Stage de code</h2>
              </div>
            </div>
            <button v-if="!displayMesEvenements" class="btn-add" @click="displayEvenements()">
              Mes inscriptions
            </button>
            <button v-else class="btn-add btn-add-secondary" @click="this.displayMesEvenements = false">
              Tous les événements
            </button>
          </div>

          <div class="filters-row" v-if="displayMesEvenements === true">
            <button class="filter-pill" :class="{ active: checkJourneeaVenir }" @click="filtreJourneeaVenir">À venir</button>
            <button class="filter-pill" :class="{ active: checkJourneePasse }" @click="filtreJourneeaPasse">Passé</button>
          </div>

          <div class="journee-list">
            <template v-if="displayMesEvenements === false">
              <div
                v-for="journee in journees"
                :key="journee.id"
                class="journee-card"
                :class="{ active: journee === journeeSelected }"
                @click="getJournee(journee)"
              >
                <div class="journee-card-header">
                  <p class="journee-title">{{ journee.libelle }}</p>
                  <div class="journee-badges">
                    <span class="journee-badge inscrit" v-if="isInscrit(journee)">✓ Inscrit</span>
                    <span class="journee-badge" :class="{ complet: journee.nbrPlace <= 0 }">
                      {{ journee.nbrPlace > 0 ? journee.nbrPlace + ' places' : 'Complet' }}
                    </span>
                  </div>
                </div>
                <div class="journee-meta">
                  <span v-if="journee.dateFin">Du {{ journee.date }} au {{ journee.dateFin }}</span>
                  <span v-else>{{ journee.date }}</span>
                  <span>{{ journee.horaireDebut }} - {{ journee.horaireFin }}</span>
                </div>
              </div>
              <p class="empty-list" v-if="journees.length === 0">Aucune journée disponible</p>
            </template>

            <template v-else>
              <div
                v-for="journee in mesJournees"
                :key="journee.id"
                class="journee-card"
                :class="{ active: journee === journeeSelected }"
                @click="getJournee(journee)"
              >
                <div class="journee-card-header">
                  <p class="journee-title">{{ journee.libelle }}</p>
                  <span class="journee-badge" :class="{ complet: journee.nbrPlace <= 0 }">
                    {{ journee.nbrPlace > 0 ? journee.nbrPlace + ' places' : 'Complet' }}
                  </span>
                </div>
                <div class="journee-meta">
                  <span>{{ journee.date }}</span>
                  <span>{{ journee.horaireDebut }} - {{ journee.horaireFin }}</span>
                </div>
              </div>
              <p class="empty-list" v-if="mesJournees.length === 0">Aucune inscription</p>
            </template>
          </div>
        </div>

        <!-- Colonne droite : détails -->
        <div class="panel panel-form">

          <template v-if="journee == null">
            <div class="empty-state">
              <div class="empty-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5">
                  <rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18M8 4V2M16 4V2"/>
                </svg>
              </div>
              <p class="empty-title">Aucune journée sélectionnée</p>
              <p class="empty-sub">Cliquez sur une journée dans la liste pour voir les détails</p>
            </div>
          </template>

          <template v-else>
            <div class="form-header">
              <h2 class="form-title">{{ journee.libelle }}</h2>
              <p class="form-sub">
                <template v-if="journee.dateFin">Du {{ journee.date }} au {{ journee.dateFin }}</template>
                <template v-else>{{ journee.date }}</template>
                — {{ journee.horaireDebut }} à {{ journee.horaireFin }}
              </p>
            </div>

            <div class="form-body">

              <!-- NON INSCRIT -->
              <template v-if="inscrit == null">
                <p class="description-text">{{ journee.description }}</p>

                <template v-if="journee.nbrPlace <= 0">
                  <p class="status-message status-danger">Cette journée est complète</p>
                </template>
                <template v-else-if="checkSessionTermine === true">
                  <p class="status-message status-danger">Session terminée</p>
                </template>
                <template v-else>
                  <div class="form-actions">
                    <button class="btn btn-primary" @click="postJourneeReserv()">
                      S'inscrire
                    </button>
                  </div>
                </template>
              </template>

              <!-- INSCRIT -->
              <template v-else>
                <p class="status-message status-success">Vous êtes inscrit à cet événement !</p>

                <p class="description-text">{{ journee.description }}</p>

                <template v-if="checkSessionTermine === true">
                  <p class="status-message status-danger">Session terminée</p>
                </template>
                <template v-else>
                  <div class="form-actions">
                    <button class="btn btn-danger" @click="deleteJourneeReserv()">Se retirer</button>
                  </div>
                </template>
              </template>

            </div>
          </template>
        </div>

      </div>
    </div>
  </template>

  <script>
  import { useToast } from "primevue/usetoast";
  import moment from "moment";
  import { FilterMatchMode } from "primevue/api";
  import HeaderHome from "@/components/home/HeaderHome.vue";

  export default {
    name: "App",

    components: {
      HeaderHome,
    },

    data() {
      return {
        toast: useToast(),
        selectedItem: null,
        displayMesEvenements: false,
        mesJournees: [],
        journees: [],
        journeesForFiltre: [],
        todayDate: new Date().toLocaleString("en-US"),
        journee: null,
        journeeSelected: null,
        mesJourneesFiltreParDate: [],
        dateForFiltre: "",
        journeeReserv: null,
        libelleStatut: "",
        checkSessionTermine: false,
        checkJourneeaVenir: false,
        checkJourneePasse: false,
        inscrit: null,
        filters: {
          nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        },
        form: {
          journeeInfoId: null,
          libelle: "",
          description: "",
          horaireDebut: "",
          horaireFin: "",
          date: "",
          nbrPlace: null,
        },
      };
    },

    mounted() {
      this.getJournees();
    },

    methods: {
      refreshJournees() {
        this.dateForFiltre = "";
        this.getJournees();
      },

      displayEvenements() {
        this.displayMesEvenements = true;
        this.filterMesJournees();
      },

      filterMesJournees() {
        this.mesJournees = this.journeesForFiltre.filter((jr) =>
          jr.journeeReservations.find(
            (jre) => jre.eleve.id === this.$store.state.user.id
          )
        );
      },

      filtreByDate() {
        let maday = moment(String(this.dateForFiltre)).format("MM-YYYY");

        this.journees = this.journeesForFiltre.filter(
          (jr) => jr.dateOnlyMonthandYear === maday
        );
      },

      filtreJourneeaVenir() {
        if (this.checkJourneeaVenir == false) {
          this.checkJourneeaVenir = true;
          this.mesJournees = this.mesJournees.filter(
            (jr) =>
              new Date(jr.dateEn).getTime() >= new Date(this.todayDate).getTime()
          );
        } else {
          this.checkJourneeaVenir = false;
          this.getJournees();
          this.filterMesJournees();

        }
      },

      filtreJourneeaPasse() {
        if (this.checkJourneePasse == false) {
          this.checkJourneePasse = true;
          this.mesJournees = this.mesJournees.filter(
            (jr) =>
              new Date(jr.dateEn).getTime() <= new Date(this.todayDate).getTime()
          );
        } else {
          this.checkJourneePasse = false;
          this.getJournees();
          this.filterMesJournees();
        }
      },

      getJournee(journee) {
        this.checkSessionTermine = false;
        this.journee = journee;
        this.journeeSelected = journee;

        let dateJournee = new Date(journee.dateEn);
        let dateNow = new Date(this.todayDate)

        if (
          dateJournee <
          dateNow
        ) {
          this.checkSessionTermine = true;
        }
        this.checkIfInscrit();
      },

      async deleteJourneeReserv() {
        try {
          if (confirm("Voulez vous vraiment vous retirer ?")) {
            window.api
              .delete("stagecode/" + this.journeeReserv.id, {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              })
              .then((response) => {
                this.getJournees();

                this.inscrit = null;
                this.toast.add({
                  severity: "success",
                  summary: "Désinscription",
                  detail: "Votre vous etes été Désinscris avec succès",
                  life: 3000,
                });
                console.log(response);
              });
          }
        } catch (e) {
          // handle authentication error here
        }
      },

      async getJournees() {
        try {
          window.api
            .get("/AllStageCode/" + this.$store.state.user.agence.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((response) => {
              this.journees = response.data.journees;
              this.journeesForFiltre = response.data.journees;
              this.journees = this.journees.filter(
                (jr) =>
                  new Date(moment(String(jr.dateEn)).format("MM-DD-YYYY")) >=
                  new Date(moment(String(this.todayDate)).format("MM-DD-YYYY"))
              );
              this.filterMesJournees();
            });


        } catch (e) {
          // handle authentication error here
        }
      },

      isInscrit(journee) {
        return (
          journee.journeeReservations &&
          journee.journeeReservations.some(
            (jr) => jr.eleve.id === this.$store.state.user.id
          )
        );
      },

      checkIfInscrit() {

        if (
          (this.journee.journeeReservations.length > 0 &&

          this.journee.journeeReservations.find(
            (jr) => jr.eleve.id === this.$store.state.user.id
          ))
        ) {
          if (
            this.journee.journeeReservations.filter(
              (jr) => jr.eleve.id === this.$store.state.user.id
            )
          ) {
            this.inscrit = true;
            this.journeeReserv = this.journee.journeeReservations.find(
              (jr) => jr.eleve.id === this.$store.state.user.id
            );
          }

        } else {
          this.inscrit = null;
        }
      },

      async postJourneeReserv() {
        if (this.journee.nbrPlace < 1) {
          this.toast.add({
            severity: "error",
            summary: "Reservation Impossible",
            detail: "Il n'y a pas assez de place pour cette Evenement",
            life: 3000,
          });
          return;
        }

        if (!confirm("Voulez vous vraiment vous inscrire ?")) {
          return;
        }

        window.api
          .post(
            "/stagecode/" + this.journee.id + "/reservation/" + this.$store.state.user.id,
            {},
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {

            this.getJournees();
            this.journeeReserv = {
              id: response.data.id,
            };

            this.inscrit = true;
            this.toast.add({
              severity: "success",
              summary: "Inscription Réussis",
              detail: "Votre Inscription à été réalisé avec succès",
              life: 3000,
            });
          })
          .catch((error) => {
            // handle authentication and validation errors here
            console.log("ERRR::", error.response.data);
          });
      },
    },
  };
  </script>

  <style>
  #horizontalSpinnerButton {
    width: 5vh !important;
    text-align: center;
  }
  </style>

  <style scoped>
  #conteneur {
    background: #f4f6f9;
    min-height: 100vh;
  }

  /* ── Layout principal ── */
  .background {
    min-height: calc(100vh - 5vh);
    width: 100%;
    display: flex;
    gap: 20px;
    padding: 24px;
    box-sizing: border-box;
  }

  /* ── Panneaux ── */
  .panel {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .panel-list {
    flex: 1 1 55%;
    min-width: 0;
  }

  .panel-form {
    flex: 0 0 42%;
    max-width: 520px;
  }

  /* ── En-tête panneau liste ── */
  .panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 22px;
    border-bottom: 1px solid #e2e8f0;
    gap: 12px;
  }

  .panel-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .panel-label {
    margin: 0;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    text-align: left;
  }

  .panel-title {
    margin: 2px 0 0;
    font-size: 17px;
    font-weight: 700;
    color: #1e293b;
    text-align: left;
  }

  .btn-add {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 9px 18px;
    background: #3b82f6;
    color: #ffffff;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.18s;
  }

  .btn-add:hover {
    background: #2563eb;
  }

  .btn-add-secondary {
    background: #f1f5f9;
    color: #475569;
  }

  .btn-add-secondary:hover {
    background: #e2e8f0;
  }

  /* ── Filtres ── */
  .filters-row {
    display: flex;
    gap: 10px;
    padding: 14px 22px 0;
  }

  .filter-pill {
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #64748b;
    border-radius: 20px;
    padding: 6px 16px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.18s;
  }

  .filter-pill:hover {
    border-color: #3b82f6;
    color: #3b82f6;
  }

  .filter-pill.active {
    background: #eff6ff;
    border-color: #3b82f6;
    color: #3b82f6;
  }

  /* ── Liste des journées ── */
  .journee-list {
    padding: 16px 22px;
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .journee-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
    cursor: pointer;
    transition: all 0.15s;
  }

  .journee-card:hover {
    border-color: #93c5fd;
    background: #f8fafc;
  }

  .journee-card.active {
    border-color: #3b82f6;
    background: #eff6ff;
  }

  .journee-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 6px;
  }

  .journee-title {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
  }

  .journee-badge {
    font-size: 11px;
    font-weight: 700;
    color: #16a34a;
    background: #dcfce7;
    padding: 3px 10px;
    border-radius: 20px;
    white-space: nowrap;
  }

  .journee-badge.complet {
    color: #dc2626;
    background: #fee2e2;
  }

  .journee-badges {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }

  .journee-badge.inscrit {
    color: #2563eb;
    background: #dbeafe;
  }

  .journee-meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #64748b;
  }

  .empty-list {
    text-align: center;
    color: #94a3b8;
    font-size: 13px;
    padding: 24px 0;
  }

  /* ── État vide (panneau droit) ── */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 48px 32px;
    text-align: center;
  }

  .empty-icon {
    width: 72px;
    height: 72px;
    background: #f1f5f9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }

  .empty-title {
    margin: 0 0 6px;
    font-size: 15px;
    font-weight: 600;
    color: #64748b;
  }

  .empty-sub {
    margin: 0;
    font-size: 13px;
    color: #94a3b8;
    max-width: 240px;
    line-height: 1.5;
  }

  /* ── En-tête formulaire ── */
  .form-header {
    padding: 20px 24px 16px;
    border-bottom: 1px solid #e2e8f0;
  }

  .form-title {
    margin: 0 0 4px;
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
  }

  .form-sub {
    margin: 0;
    font-size: 13px;
    color: #64748b;
  }

  /* ── Corps du formulaire ── */
  .form-body {
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
  }

  .description-text {
    margin: 0;
    font-size: 13px;
    color: #475569;
    line-height: 1.6;
  }

  .field-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .field-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #64748b;
  }

  .status-message {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    padding: 10px 14px;
    border-radius: 10px;
  }

  .status-success {
    color: #16a34a;
    background: #dcfce7;
  }

  .status-danger {
    color: #dc2626;
    background: #fee2e2;
  }

  /* ── Actions ── */
  .form-actions {
    display: flex;
    gap: 10px;
    padding-top: 4px;
  }

  .btn {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 10px 18px;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.18s, opacity 0.18s;
  }

  .btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }

  .btn-primary {
    background: #3b82f6;
    color: #ffffff;
  }

  .btn-primary:hover:not(:disabled) {
    background: #2563eb;
  }

  .btn-danger {
    background: #fee2e2;
    color: #dc2626;
  }

  .btn-danger:hover:not(:disabled) {
    background: #fecaca;
  }

  /* ===== RESPONSIVE ===== */
  @media (max-width: 900px) {
    .background {
      flex-direction: column;
      padding: 16px;
      gap: 16px;
    }

    .panel-form {
      max-width: 100%;
    }

    .panel-list {
      max-height: 60vh;
    }
  }

  @media (max-width: 600px) {
    .background {
      padding: 10px;
      gap: 12px;
    }

    .panel-header {
      flex-wrap: wrap;
      padding: 14px 16px;
    }

    .filters-row {
      padding: 12px 16px 0;
      flex-wrap: wrap;
    }

    .journee-list {
      padding: 12px 16px;
    }

    .journee-card-header {
      flex-wrap: wrap;
    }

    .journee-meta {
      flex-direction: column;
      gap: 2px;
    }

    .form-header {
      padding: 16px;
    }

    .form-body {
      padding: 16px;
    }

    .form-actions {
      flex-direction: column;
    }

    .empty-state {
      padding: 32px 16px;
    }
  }
  </style>
